/* NM Sidebar lazy-render (performance)
   Renders only the first N sidebar/mobile menu links in Liquid.
   The remaining links are stored as JSON and appended on demand.
*/
(function(){
  "use strict";

  function qsa(sel, root){
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function parseJSON(el){
    if (!el) return [];
    try { return JSON.parse(el.textContent || "[]"); } catch(e) { return []; }
  }

  function buildLi(link){
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = link.u || '#';
    a.textContent = link.t || '';
    if (link.a) a.classList.add('is-active');
    li.appendChild(a);
    return li;
  }

  function init(){
    var buttons = qsa('[data-nm-lazy-btn]');
    if (!buttons.length) return;

    buttons.forEach(function(btn){
      var key = btn.getAttribute('data-nm-lazy-btn');
      var jsonEl = document.querySelector('.nm-lazy-links[data-nm-lazy="' + key + '"]');
      var data = parseJSON(jsonEl);
      if (!data.length) return;

      var nav = btn.closest('.sidebar-module, .mobile-nav__link');
      var list = nav ? nav.querySelector('ul') : null;
      if (!list) return;

      var appended = [];

      btn.addEventListener('click', function(){
        var expanded = btn.classList.toggle('is-expanded');
        if (expanded){
          // expand
          data.forEach(function(l){
            var li = buildLi(l);
            appended.push(li);
            list.appendChild(li);
          });
        } else {
          // collapse
          appended.forEach(function(li){
            if (li && li.parentNode) li.parentNode.removeChild(li);
          });
          appended = [];
        }
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { passive: true });
  } else {
    init();
  }
})();
